<template>
  <div>
<!--     <div class="vld-parent mycenter">
      <loading :active.sync="isLoading" 
      :is-full-page="fullPage"></loading>
    </div>   -->    
    <MovieList :movies="movies" v-if="dorms"/>
<!--     <infinite-loading @infinite="infiniteHandler" spinner="waveDots">
    <div slot="no-more"></div>
    <div slot="no-results"></div>
    </infinite-loading>    --> 
    <FixedPopup :dorms="popupDorms" v-if="popupDorms && popupDorms.length > 0"/>
  </div>
</template>

<script>
import { SET_TOTAL_RESULTS } from '@/store/mutations.type'
import MovieList from '@/components/MovieList'
import FixedPopup from '@/components/FixedPopup'
import axios from 'axios'
import InfiniteLoading from 'vue-infinite-loading'
import Loading from 'vue-loading-overlay';
import { mapGetters } from 'vuex'
export default {
  name: 'BranchMain',
  components: {
    MovieList,
    FixedPopup,
    InfiniteLoading,
    Loading
  },
  metaInfo () {
    return {
      // http://api.holywoodskyline.com/site/series/batman
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.branchedDormTitle ? this.branchedDormTitle : '',
      meta: [
        { vmid: 'description', name: 'description', content: this.universityDetails ? this.universityDetails.description : '' },
        { vmid: 'keywords', name: 'keywords', content: this.universityDetails ? this.universityDetails.keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath },
      ]       
    }
  },
  data () {
    return {
      branchedDormTitle: null,
      fullPath: '',
      isLoading: false,
      fullPage: true, 
      page: 2,
      movies: [],
      pagination: null,
      popupDorms: null,
      errors: []
    }
  },
  methods: {
    infiniteHandler ($state) {
      let self = this
      axios.get(`/site/universities/dorms/${this.$route.params.slug}?page=${this.page}`)
        .then(response => {
          // self.pagination = response.data.data
            //if (Array.isArray(self.dorms) && Array.isArray(response.data.data.data) !== true && Object.keys(response.data.data.data).length !== 0) {
            if (response.data.results.length !== 0 ) {              
              response.data.results.forEach(item => {
                self.movies.push(item)
              })
              $state.loaded()
            } else {
              $state.complete()
            }          
          // self.dorms = response.data.data.data
          self.popupDorms = response.data.popups
        })
        .catch(e => {
          self.errors.push(e)
        })      
    },
  getMovies() {
    const id = window.localStorage.getItem('branchedDormId')
    var self = this
       const url = `/3/collection/${this.$route.params.id}?api_key=a11ac97c6bdb99adc0845654be0902a8&language=en-US`
       // let distinctArray = null
       axios.get(url)
         .then(response => {
           self.$store.commit(SET_TOTAL_RESULTS, response.data.total_results)
           this.isLoading = false
           self.detail = response.data
           this.branchedDormTitle = response.data.name
           window.localStorage.setItem('dormLogo', response.data.logo)
           window.localStorage.setItem('branchedDormTitle', response.data.center_name)
           if(response.data.parts) {
             // distinctArray = [...new Set(response.data.branches.map(x => x.district.name))]
             window.localStorage.setItem('branchnumber', response.data.branches.length) 
             self.movies = response.data.parts
             self.allDorms = response.data.parts
           }        
    })
  },
   
  },
  computed: {
    ...mapGetters(['universityDetails'])
  },
  mounted () {
    this.getMovies()
  },
  created() {
    // this.branchedDormTitle = window.localStorage.getItem('branchedDormTitle')  
    var myString = this.$route.fullPath
    var lastChar = myString[myString.length -1];
    
    if(lastChar === '/') {
        this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }
  },
  watch: {
    $route () {
      this.getMovies()
    }
  }
}
</script>

<style scoped>
.mycenter {
 display:table;
 margin:0 auto;
}
</style>
